import { MERGE_TAGS } from "utilities/enums"

/** Guest merge tags available in email subject lines. */
// eslint-disable-next-line import/prefer-default-export
export const SUBJECT_LINE_MERGE_TAGS = MERGE_TAGS.filter(
  ({ id }) => !["CONFIRMATION_URL", "GUEST_QR_PAGE_URL", "EVENT_NAME"].includes(id),
)
